import { inject, Injectable } from "@angular/core"
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { GetPaginatedFavorites, PostFavorite, DeleteFavorite, DeleteAllFavorite } from "./favorites.actions";
import { FavoritesState } from "./favorites.state";
import { Favorite, PaginatedFavorites } from "./models/favorites.response";

@Injectable({
  providedIn: 'root',
})
export class FavoritesFacade {

  private readonly store = inject(Store);

  @Select(FavoritesState.getPaginatedFavorites) paginatedFavorites$!: Observable<PaginatedFavorites>;
  @Select(FavoritesState.favoriteAdded) favoriteAdded$!: Observable<Favorite>;
  @Select(FavoritesState.favoriteRemoved) favoriteRemoved$!: Observable<Favorite>;
  @Select(FavoritesState.isLoading) isLoading$!: Observable<boolean>;

  get paginatedFavorites() {
    return this.store.selectSnapshot(FavoritesState.getPaginatedFavorites);
  }

  get favoriteAdded() {
    return this.store.selectSnapshot(FavoritesState.favoriteAdded);
  }

  get favoriteRemoved() {
    return this.store.selectSnapshot(FavoritesState.favoriteRemoved);
  }

  getPaginatedFavorites(limit = 10, offset = 0): Observable<GetPaginatedFavorites> {
    return this.store.dispatch(new GetPaginatedFavorites(limit, offset));
  }

  postFavorite(favoriteId: string): Observable<PostFavorite> {
    return this.store.dispatch(new PostFavorite(favoriteId));
  }

  deleteFavorite(favoriteId: string): Observable<DeleteFavorite> {
    return this.store.dispatch(new DeleteFavorite(favoriteId));
  }

  deleteAllFavorites(): Observable<DeleteAllFavorite> {
    return this.store.dispatch(new DeleteAllFavorite());
  }

  getFavoriteByRecordId(recordId: string): Favorite {
    return this.paginatedFavorites?.items.find((favorite) => favorite.recordId === recordId);
  }
}